import { render } from "./NotificationListButton.vue?vue&type=template&id=ff7852b2&scoped=true&ts=true"
import script from "./NotificationListButton.vue?vue&type=script&lang=ts"
export * from "./NotificationListButton.vue?vue&type=script&lang=ts"

import "./NotificationListButton.vue?vue&type=style&index=0&id=ff7852b2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff7852b2"]])

export default __exports__